// Avatar par défaut généré en mémoire (disque de couleur + initiales), utilisé tant qu'aucune photo n'est définie.

export const getInitials = (firstname: string, lastname: string, fallback: string = ''): string => {
  const initials = `${firstname.trim().charAt(0)}${lastname.trim().charAt(0)}`.toUpperCase();
  return initials !== '' ? initials : fallback.trim().charAt(0).toUpperCase();
};

export const generateInitialsAvatarDataUrl = (
  initials        : string,
  size            : number = 200,
  backgroundColor : string = '#2563EB',
  textColor       : string = '#FFFFFF',
): string => {

  if (initials === '') return '';

  const canvas = document.createElement('canvas');
  canvas.width  = size;
  canvas.height = size;

  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  ctx.fillStyle = backgroundColor;
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle    = textColor;
  ctx.font         = `${Math.round(size * 0.4)}px sans-serif`;
  ctx.textAlign    = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(initials, size / 2, size / 2);

  return canvas.toDataURL('image/png');
};

// Nombre d'abonnés compact au-delà de 1000 (ex: 1000 → "1 K", 1230 → "1,23 K").
export const formatSubscriberCount = (count: number): string => {

  if (count < 1000) return `${count}`;

  const thousands = Math.round((count / 1000) * 100) / 100;
  const formatted = thousands.toFixed(2).replace(/\.?0+$/, '');

  return `${formatted.replace('.', ',')} K`;
};

// "—" si la date est absente ou invalide (ex: chaîne non parsable renvoyée par le backend)
export const formatDateOrDash = (date: Date | null): string =>
  date && !isNaN(date.getTime()) ? date.toLocaleString() : '—';
